import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ICard } from '../Card'

import { InlinePlaySolidButton } from 'atoms/Button/Templates'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { CARDS_ASPECT_RATIO, CardAnimations } from '../Card.h'
import { CardContent, SidebarCardStyled } from './SidebarCard.styled'

export interface ISidebarCardProps extends Omit<ICard, 'children'> {
  title?: ITextBoxProps['title']
}

export const SidebarCard = ({
  posterUrl = '',
  title = '',
  width,
  height = '100%',
  aspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
  childrenTransition = CardAnimations.FadeIn,
  ...rest
}: ISidebarCardProps): JSX.Element => (
  <SidebarCardStyled
    posterUrl={posterUrl}
    width={width}
    height={height}
    aspectRatio={aspectRatio}
    childrenTransition={childrenTransition}
    {...rest}
  >
    <CardContent>
      <InlinePlaySolidButton />
      {title ? (
        <TextBox
          title={title}
          font={TextBoxTypes.Footnote5}
          color={TextBoxColors.TEXT_ICON_PRIMARY}
          maxLines={1}
        />
      ) : null}
    </CardContent>
  </SidebarCardStyled>
)
